import { gsap } from 'gsap';
function Animate(sprite, { duration = 1, speed = 1, ease = 'power3.out', type, elementToAnimate, delayValue }) {
  let animation;
  duration = duration * speed;
  let steps = elementToAnimate?.length || 1;
  if (type == 'entry') {
    animation = gsap.from(elementToAnimate, {
      duration: duration,
      pixi: {
        blur: sprite.height / 5, //blur by 1/5 the height
        // y: function (index, target) {
        //   //console.log(target);
        //   return target.y + sprite.height / 5;
        // },
        alpha: 0, //fade in
      },
      repeat: 0,
      delay: delayValue,
      ease: 'power3.out',
      stagger: duration / steps,
    });
  } else {
    animation = gsap.to(elementToAnimate, {
      duration: duration,
      pixi: {
        blur: sprite.height / 5, //blur by 1/5 the height
        // y: function (index, target) {
        //   //console.log(target);
        //   return target.y + sprite.height / 5;
        // },
        alpha: 0, //fade in
      },
      repeat: 0,
      delay: steps > 1 ? delayValue - duration : delayValue,
      ease: 'power3.in',
      stagger: duration / steps,
    });
  }
  return animation;
}
export default { Animate };
